import clsx from 'clsx'

export interface LabelProps {
	label: string
	isRequired?: boolean
	className?: string
	disabled?: boolean
	htmlFor?: string
	style?: React.CSSProperties
}

export function Label({ label, isRequired = false, className = '', disabled = false, htmlFor, style }: LabelProps) {
	return (
		<label
			htmlFor={htmlFor}
			className={clsx(`text-white font-semibold text-sm capitalize leading-normal`, className, {
				'opacity-50': !!disabled,
			})}
			style={style}
		>
			{label} {isRequired && <span className="text-primary">*</span>}
		</label>
	)
}
